/**
 *
 * @description: 进门-irm
 *
 */
import { isThirdPartyMode, BridgeBase } from './bridge_utils';

const brmChannel = 'irm';

export const isThirdParty = isThirdPartyMode({ brmChannel, noComeinChannel: true });

if (isThirdParty) window.comeinChannel = 'irm';

/**
 * 进宝模块配置：挂在 `jinbaoModules` 下，避免与 Bridge 实例上其它字段名冲突；业务侧仅通过 resolveJinbaoModuleConfig / 各模块 hook 读取
 *
 * 功能标识说明：
 * - cloudDoc: 云文档相关（知识库-云文档、存至云文档按钮等）
 * - hideShareToQa: 隐藏「分享至问答」及会话栏分享入口
 * - brmNavigation: BRM个股/概念详情页跳转
 * - commentCollect: 点评收藏按钮
 * - learnMoreAboutCompany: 了解公司更多信息按钮
 * - historyFilter: 历史记录筛选按钮
 * - addStock: 个股弹框添加自选按钮
 * - reportJumpIrm: 内资研报详情页跳转至IRM
 * - hideCopyImgBtn: 隐藏图表块「复制图片」按钮
 * - showOpenClaw: 展示OpenClaw功能
 * - disableOpenClawChatLinks: 进宝任务模式聊天中正文/思考内容里的URL不可点击
 * - hideOpenClawPrompts: 隐藏OpenClaw提示词
 */
const JINBAO_MODULES_IRM = {
  chat: {
    hideCloudDoc: true,
    hideShareToQa: true,
    hideBrmNavigation: true,
    hideCommentCollect: true,
    hideLearnMoreAboutCompany: true,
    hideHistoryFilter: true,
    hideAddStock: true,
    reportJumpIrm: true,
    hideCopyImgBtn: true
  },
  claw: {
    showOpenClaw: true,
    disableOpenClawChatLinks: true,
    hideOpenClawPrompts: false
  },
  researchBrain: {
    hideCloudDoc: true
  }
};

const DAILY_MODULE_CONFIG = {
  /** 禁用股票跳转 */
  disableRelateStockNavigation: true,
  /** 禁用关联股票自选 */
  disableRelateStockAttention: true,
  /** 禁用纪要跳转 */
  disableSummaryDetailJump: true,
  hideBrmNavigation: true,
  hideCommentCollect: true
};
// 进门-irm Bridge类 - 使用默认实现
class Bridge extends BridgeBase {
  constructor() {
    super(brmChannel, true);
    this.hideLogoutBtn = false;
    this.jinbaoModules = {
      chat: { ...JINBAO_MODULES_IRM.chat },
      claw: { ...JINBAO_MODULES_IRM.claw },
      researchBrain: { ...JINBAO_MODULES_IRM.researchBrain }
    };
    this.dailyModuleConfig = { ...DAILY_MODULE_CONFIG };
  }
}

// 导出实例作为默认导出（用于直接使用）
export default new Bridge();

// 同时导出类（用于 bridge.js 的原型链合并）
export { Bridge };
